import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { ServerMonitorService } from '../../../services/server-monitor.service';
import { NoServerDialogBodyComponent } from '../no-server-dialog-body/no-server-dialog-body.component';
import { NavigationService } from './../../../../navigation/navigation.service';

@Component({
    selector: 'app-no-server-dialog',
    template: ''
})
export class NoServerDialogComponent implements OnInit, OnDestroy {
    private sub: Subscription;

    dialogRef: MatDialogRef<NoServerDialogBodyComponent>;

    constructor(
        private readonly serverMonitorService: ServerMonitorService,
        private readonly navigationService: NavigationService,
        public dialog: MatDialog
    ) {}

    ngOnInit() {
        this.sub = this.serverMonitorService.offline$.subscribe(isOffline => {
            if (isOffline) {
                this.openConnectionLostDialog();
            } else {
                this.closeConnectionLostDialog();
                this.navigationService.refresh();
            }
        });
    }

    openConnectionLostDialog() {
        if (!this.dialogRef) {
            this.dialogRef = this.dialog.open(NoServerDialogBodyComponent, {
                disableClose: true,
                closeOnNavigation: false,
                hasBackdrop: true
            });
        }
    }

    closeConnectionLostDialog() {
        if (this.dialogRef) {
            this.dialogRef.close();
            this.dialogRef = null;
        }
    }

    ngOnDestroy() {
        if (this.sub) {
            this.sub.unsubscribe();
        }
    }
}
